export type TruncatedListProps = Readonly<{
  items: string[]
  emptyText?: string
}>
